import VehiclesRoutes from './routes'
export default VehiclesRoutes



// WEBPACK FOOTER //
// ./src/containers/vehicles/routes/index.js